import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=21562eda&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=21562eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21562eda",
  null
  
)

export default component.exports